import { db, FieldValue } from "@/firebase/config";
import { contentCollectionRef } from "./content";


export const creatorCollectionRef = type => db.collection(type + 's');

export const getContentCreators = (contentID, type) => {
    return creatorCollectionRef(type).where('contents', 'array-contains', contentID);
}

export const createCreatorWithContent = async (creator, chapterID, contentID, type) => {
    try {
        creator.contents = [contentID];
        let newCreatorRef = await creatorCollectionRef(type).add(creator);
        let contentRef = contentCollectionRef(chapterID).doc(contentID);

        await contentRef.update({
            creators: FieldValue.arrayUnion(newCreatorRef.id)
        });
        return newCreatorRef.id;
    } catch (exception) {
        return null;
    }
};

export const updateCreator = async (creatorID, newCreator, type) => {
    try {
        await creatorCollectionRef(type).doc(creatorID).update(newCreator);
        return true;
    } catch (exception) {
        return null;
    }
};

export const deleteCreator = async (creatorID, type) => {
    try {
        await creatorCollectionRef(type).doc(creatorID).delete();
        return true;
    } catch (exception) {
        return false;
    }
};

export const addCreatorToContent = async (creatorID, chapterID, contentID, type) => {
    try {
        let contentRef = contentCollectionRef(chapterID).doc(contentID);
        await creatorCollectionRef(type).doc(creatorID).update({
            contents: FieldValue.arrayUnion(contentID)
        });
        await contentRef.update({
            creators: FieldValue.arrayUnion(creatorID)
        });
        return true;
    } catch (exception) {
        return null;
    }
};

export const removeCreatorFromContent = async (creatorID, chapterID, contentID, type) => {
    try {
        let contentRef = contentCollectionRef(chapterID).doc(contentID);
        await creatorCollectionRef(type).doc(creatorID).update({
            contents: FieldValue.arrayRemove(contentID)
        });
        await contentRef.update({
            creators: FieldValue.arrayRemove(creatorID)
        });
        return true;
    } catch (exception) {
        return null;
    }
};
